





































import { chat_message } from "@/shared/classes/chat_message";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";


@Component({ components: {} })
export default class messages_list extends Vue {
  @Prop({ type: Array, required: true }) public messages!: chat_message[];
  @Prop({ type: Boolean, default: false }) public isLoading!: boolean;

  get safeMessages(): chat_message[] {
    return this.messages.filter(function(m: chat_message) { return m.role !== "system"; });
  }

  @Watch("messages")
  onMsgsChanged() { this.scrollToBottom(); }

  private scrollToBottom(): void {
    var self: any = this;
    this.$nextTick(function() {
      const el = self.$refs["messagesContainer"] as HTMLElement | undefined;
      if (el) { el.scrollTop = el.scrollHeight; }
    });
  }

  public formatMd(text: string): string {
    if (!text) return "";
    var t = text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    t = t.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");
    t = t.replace(/\*(.+?)\*/g, "<em>$1</em>");
    t = t.replace(/\n/g, "<br/>");
    return t;
  }
}
